module.exports = __webpack_public_path__ + "img/settings/Wowza.b59458.png";